import { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import {
  Box,
  Button,
  Icon,
  Image,
  LoadingOverlay,
  Text,
  useToast,
} from '@redriverpress/system'
import xhr from 'Common/utils/xhr'

import Welcome from 'Images/welcome.svg'
import { STD_ONBOARDING_PATH } from '../common/constants'
import {
  useStudentOnboardingContext,
  setClassCode,
  setYumiClass,
  setIsInvitation,
  setCurrentStep,
} from '../context/onboardingStudentContext'
import Loc from '../common/components/Loc'
import findClassByCode from '../common/endpoints'

import LanguageHelp from '../common/components/LanguageHelp'

const CreateAccountButton = styled(Button)`
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.black};
  background-color: ${props => props.theme.colors.blue400};
  &:hover,
  &:focus {
    background: ${props => props.theme.colors.blue300};
    color: ${props => props.theme.colors.black};
  }
`

const LogInButton = styled(Button)`
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.black};
  background-color: ${props => props.theme.colors.yellow400};
  &:hover,
  &:focus {
    background: ${props => props.theme.colors.yellow300};
    color: ${props => props.theme.colors.black};
  }
`

export default function ChoosePath() {
  const history = useHistory()
  const [error, setError] = useState(false)
  const { addToast } = useToast()
  const [{ locale }, dispatch] = useStudentOnboardingContext()
  const location = useLocation()
  const param = new URLSearchParams(location.search)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const classCodeParam = param.get('class_code')

    if (classCodeParam) {
      dispatch(setIsInvitation(true))
      setLoading(true)
      xhr({
        url: findClassByCode(classCodeParam),
        method: 'GET',
      })
        .then(res => {
          setLoading(false)
          dispatch(setYumiClass(res.data))
          dispatch(setClassCode(classCodeParam))
        })
        .catch(() => {
          setLoading(false)
          setError(true)
          addToast({
            id: 'class-code-error',
            content: 'Invalid link. Please ask your teacher for the new link.',
            type: 'warning',
          })
        })
    } else {
      dispatch(setIsInvitation(false))
    }
  }, [location])

  useEffect(() => {
    dispatch(setCurrentStep(null))
  }, [])

  return (
    <>
      {loading && <LoadingOverlay />}
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        minHeight='90vh'
      >
        <Box display='flex' flexDirection='column' alignItems='center' mt={5}>
          <Image
            title='welcome'
            alt='Welcome'
            src={Welcome}
            height='70px'
            mb={2}
          />
          <Text
            as='h1'
            fontSize={5}
            fontWeight='600'
            letterSpacing='compressed'
            my={0}
            lineHeight='body'
          >
            Welcome
          </Text>
          {!!locale && (
            <Loc fontSize={1} color='gray700' fontWeight='600' copy='Welcome' />
          )}
        </Box>

        <Box
          display='flex'
          flexDirection={['column', null, null, 'row']}
          width={[1, null, '70%', '50%']}
          justifyContent='center'
          mt={5}
        >
          <Box mx={2} mb={[3, null, null, 0]} flex='1' textAlign='center'>
            <CreateAccountButton
              width={1}
              onClick={() => {
                history.push({ pathname: STD_ONBOARDING_PATH.signup })
              }}
              disabled={error}
            >
              <Icon icon='sparkles' mr={2} />
              I’m new
            </CreateAccountButton>

            {!!locale && (
              <Loc
                fontSize={[0, null, 1]}
                color='gray700'
                fontWeight={['400', null, '600']}
                copy='I’m new'
              />
            )}
          </Box>
          <Box mx={2} flex='1' textAlign='center'>
            <LogInButton
              width={1}
              onClick={() => {
                history.push({ pathname: STD_ONBOARDING_PATH.login })
              }}
              disabled={error}
            >
              <Icon icon='sign-in' mr={2} />
              Log in
            </LogInButton>

            {!!locale && (
              <Loc
                fontSize={[0, null, 1]}
                color='gray700'
                fontWeight={['400', null, '600']}
                copy='Log in'
              />
            )}
          </Box>
        </Box>
        <LanguageHelp mt='auto' mb={4} />
      </Box>
    </>
  )
}
